// Supported language pairs for Avatar Tutor conversations
export const SUPPORTED_AVATAR_TUTOR_LANGUAGE_PAIRS = [
  42, // English → Spanish (Mexico)
  2, // English → Spanish
  43, // English (US) → Spanish (Mexico)
  10, // English (US) → Spanish
];

// Persona IDs for different user levels
export const AVATAR_TUTOR_PERSONA_IDS = {
  BEGINNER: 'pc68af4ea323', // Levels 1-10
  ELEMENTARY: 'p3934efd641b', // Levels 11-15
  INTERMEDIATE: 'pf699ec5af50', // Levels 16+
} as const;
